export default "__VITE_ASSET__DXm5gYGv__$_?url__"